import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20abstract%20digital%20artwork%20featuring%20elegant%20flowing%20geometric%20shapes%20resembling%20spreadsheet%20grids%20and%20dynamic%20data%20visualization%20patterns%20in%20soft%20pastel%20tones%2C%20ethereal%20warm%20light%20gradients%2C%20minimalist%20clean%20composition%2C%20subtle%20translucent%20floating%20data%20elements%2C%20contemporary%20SaaS%20aesthetic%2C%20airy%20professional%20atmosphere%2C%20soft%20diffused%20lighting&width=1800&height=1200&seq=hero-vigorbuy-v2-2026&orientation=landscape')`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
            <i className="ri-verified-badge-line text-accent-400 text-sm"></i>
            <span className="text-xs font-medium text-background-50">Comprehensive VigorBuy Spreadsheet Resource</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            VigorBuy Spreadsheet:
            <br />
            <span className="text-accent-300">Complete Guide, Reviews &amp; Templates</span>
          </h1>

          <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-10 leading-relaxed">
            Discover everything about VigorBuy Spreadsheet including features, templates,
            comparisons, security information, and practical productivity strategies.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white font-semibold text-sm rounded-full hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              VigorBuy Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-white font-semibold text-sm rounded-full border border-background-50/30 hover:bg-background-50/25 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
            <Link
              to="/article/what-is-vigorbuy-spreadsheet"
              className="w-full sm:w-auto px-8 py-3.5 text-white font-medium text-sm rounded-full hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              Read Complete Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 mt-10">
            {[
              { icon: 'ri-shield-check-line', text: 'Comprehensive Spreadsheet Resource' },
              { icon: 'ri-lock-line', text: 'Security Focused Information' },
              { icon: 'ri-refresh-line', text: 'Updated Guides &amp; Tutorials' },
              { icon: 'ri-scales-3-line', text: 'Expert Comparison Analysis' },
            ].map((badge) => (
              <div key={badge.text} className="flex items-center gap-2 text-background-200/80 text-xs">
                <div className="w-6 h-6 rounded-full bg-accent-500/20 flex items-center justify-center">
                  <i className={`${badge.icon} text-accent-400 text-xs`}></i>
                </div>
                <span className="whitespace-nowrap">{badge.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}